var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import LocalizedStrings from 'react-localization';
var LocalizedStringsTranslator = /** @class */ (function () {
    function LocalizedStringsTranslator(languages) {
        this.localizedStrings = new LocalizedStrings(languages);
        this.locale = Object.keys(languages)[0];
        this.rawLanguages = languages;
    }
    LocalizedStringsTranslator.prototype.translate = function (key) {
        var _a;
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        var value = this.localizedStrings.getString(key);
        if (!value) {
            throw "Localization for key ".concat(key, " does not exist!");
        }
        if (values.length) {
            return (_a = this.localizedStrings).formatString.apply(_a, __spreadArray([value], values, false));
        }
        return value;
    };
    LocalizedStringsTranslator.prototype.getLocale = function () {
        return this.locale;
    };
    LocalizedStringsTranslator.prototype.setLocale = function (locale) {
        this.localizedStrings.setLanguage(locale);
    };
    LocalizedStringsTranslator.prototype.getLanguages = function () {
        return this.rawLanguages;
    };
    return LocalizedStringsTranslator;
}());
export default LocalizedStringsTranslator;
